import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";
import { useEffect } from "react";

import { Logger } from "@moment/logging";

import { paths } from "../../internal/paths";

const logger = new Logger("usePathGetPageDir");

export const usePathPageDir = (documentId: string, pageId: string, pagePath?: string) => {
	const pathsApi = paths();
	const path = useAtomValue(loadable(pathsApi.getPageDirPath({ documentId, pageId, pagePath })));

	useEffect(() => {
		if (path.state === "hasError") {
			logger.error("Error loading page directory path", { error: path.error });
		}
	}, [path.state]);

	return {
		path: path.state === "hasData" ? path.data : undefined,
		isLoading: path.state === "loading",
		isError: path.state === "hasError",
	};
};
